import { Link } from "react-router-dom";
import {useEffect} from "react"

import "./style/error.scss";
// import logoBlack from "../assets/gt-home logo.svg";
import logoBlack from "../assets/logo.svg";

function NotFound() {
  useEffect(() => {
    document.title = "Page Not found - 404"
  }, [])
  return (
    <div className="error">
      <div className="center">
        <img className="img" src={logoBlack} alt="GT Home logo" />
        <h1>Page Not Found - 404</h1>
        <h3>Go to Home Page - ارجع لصفحة الرئيسية</h3>
        <Link to="/">Home Page - الرئيسية</Link>
      </div>
    </div>
  );
}
export default NotFound;
